<template>
  <b-field label="Password Strength" horizontal>
    <b-select v-model="value">
      <option v-for="choice in choices" :value="choice" :key="choice">{{ choice }}</option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  name: 'frontend-registration-password-strength',
  props: ['value'],
  data() {
    return {
      choices: ['low', 'medium', 'height'],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Frontend/RegistrationPasswordStrength.vue